import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import ParentPaymentTypesActions, {
  ParentPaymentTypesRedux,
  ParentPaymentTypesTypes,
} from '../Redux/ParentPaymentTypesRedux'

const ParentPaymentTypesCRUDObservable = createCRUDObservable({
  mainRedux: ParentPaymentTypesRedux,
  reduxPath: 'parent_payment_types',
})

const getParentPaymentEpic = (action$, store, { Api }) => (
  action$.ofType(ParentPaymentTypesTypes.getParentPaymentRequest)
    .mergeMap(({ centerId }) => (
      Observable
        .fromPromise(Api.parent_payment_types.centerParentPayment(centerId)
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response

          if (!(status >= 200 && status < 300)) {
            return [
              ParentPaymentTypesActions.getParentPaymentError(response.error),
            ]
          }

          return [
            ParentPaymentTypesActions.getParentPaymentSuccess(response.data.data),
          ]
        })
    ))
)
export const ParentPaymentTypesObservers = Object.assign(
  {},
  ParentPaymentTypesCRUDObservable.observers,
  {},
)

export const ParentPaymentTypesEpic = combineEpics(
  ParentPaymentTypesCRUDObservable.epic,
  getParentPaymentEpic,
  )



// WEBPACK FOOTER //
// ./src/Data/Observables/ParentPaymentTypesObservable.js